import React, { Fragment, useState, useContext } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Redirect } from "react-router-dom";

import { withStyles, makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Dialog,
  Grid,
  DialogContent,
  DialogActions,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";
import { Cancel, EventOutlined } from "@material-ui/icons";
import { Alert } from "@material-ui/lab";
import axios from "axios";

import { cardBodyStyle } from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

const MuiDialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(DialogContent);

const MuiDialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(DialogActions);

export default function ChangeStatusJobsPsychometrics(props) {
  const classes = useStyles();

  const [openAlert, setOpenAlert] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [severity, setSeverity] = useState("success");
  const [returnLogin, setReturnLogin] = React.useState(false);
  const [confirmChecked, setConfirmChecked] = useState(false);

  const { urlServices, keyAplication } = useContext(UrlServicesContext);

  let keyAuthorization = localStorage.getItem("Session");

  const accountId = localStorage.getItem("account_id");

  let data = props.id;

  const handleCloseDialog = (pro) => (event) => {
    props.exit();
  };

  const handleEnable = () => {
    setOpenAlert(false);
    const dataValue = {
      status: data.status,
    };

    axios
      .put(`${urlServices}jobs-tpm/${data.data.id}`, dataValue, {
        headers: {
          application: keyAplication,
          Authorization: "Bearer " + keyAuthorization,
        },
      })
      .then((response2) => {
        setMensaje("Registro actualizado con éxito.");
        setSeverity("success");
        setOpenAlert(true);
        props.callBackRefresh();

        // Generar clave al darle publicar
        if (data.status === 1) {
          axios
            .post(
              `${urlServices}job-passwords/job/${data.data.id}/create`,
              {},
              {
                headers: {
                  application: keyAplication,
                  Authorization: "Bearer " + keyAuthorization,
                },
              },
            )
            .catch((e) => console.log("Error generando clave:", e));
        }
      })
      .catch((e) => {
        if (e.response.status === 401) {
          setTimeout(() => {
            localStorage.clear();
            setReturnLogin(true);
          }, 200);
        } else {
          setMensaje("Error al registrar!!");
          setSeverity("error");
          setOpenAlert(true);
        }
      });
  };

  if (returnLogin) {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      <Dialog
        fullWidth
        maxWidth="sm"
        onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        PaperProps={{
          classes: { root: classes.DialogStyle },
        }}
      >
        <MuiDialogContent dividers>
          <Grid container>
            <Grid item xs={12} md={12} style={{ paddingTop: 30 }}>
              <center>
                <EventOutlined style={{ fontSize: 50, color: "ref" }} />
                <br></br>
                <div className={classes.titleCardFilter}>
                  ¿Desea {data.status === 1 ? "publicar" : "finalizar"} esta
                  prueba?
                </div>
              </center>
            </Grid>
            <Grid item xs={12} sm={12} style={{ fontSize: 16 }}>
              {data.status === 1 && data?.data?.jobsteststpm?.length > 0 && (
                <>
                  <Alert severity="warning">
                    Por favor, comparta con el candidato el código de
                    institución <b style={{ fontSize: 18 }}>{accountId}</b> que
                    necesitará para acceder al sistema con su clave y aplicar al
                    cargo.
                  </Alert>
                  <br />
                  <div
                    style={{
                      fontSize: 14,
                      fontWeight: "bold",
                      color: "#000",
                      marginBottom: 6,
                    }}
                  >
                    Pruebas asignadas a este cargo:
                  </div>
                  <div
                    style={{
                      border: "1px solid rgb(241, 241, 241)",
                      borderRadius: 8,
                      padding: "8px 12px",
                      marginBottom: 10,
                      background: "#fafafa",
                    }}
                  >
                    {data.data.jobsteststpm.map((item) => (
                      <div
                        key={item.id}
                        style={{
                          padding: "4px 0",
                          fontSize: 12,
                          borderBottom: "1px solid rgb(241, 241, 241)",
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        {item.test?.name}
                      </div>
                    ))}
                  </div>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={confirmChecked}
                        onChange={(e) => setConfirmChecked(e.target.checked)}
                        color="primary"
                      />
                    }
                    label={
                      <span style={{ fontSize: 14, color: "#000" }}>
                        Confirmo que las pruebas asignadas son correctas y deseo
                        publicar este cargo.
                      </span>
                    }
                  />
                </>
              )}
              <br />
            </Grid>
            <Grid item xs={12} md={12}>
              {openAlert && (
                <Alert severity={severity === "error" ? "error" : "success"}>
                  {mensaje}
                </Alert>
              )}
            </Grid>
            <Grid item xs={12} md={12}>
              {!openAlert && (
                <center>
                  {data.status === 1 &&
                  (!data?.data?.jobsteststpm?.length ||
                    data?.data?.jobsteststpm?.length === 0) ? (
                    <Alert severity="error" style={{ textAlign: "left" }}>
                      No es posible publicar este cargo. Debe seleccionar al
                      menos una prueba antes de publicar.
                    </Alert>
                  ) : (
                    <Button
                      className={classes.buttonSubmit2}
                      onClick={handleEnable}
                      disabled={data.status === 1 && !confirmChecked}
                    >
                      {data.status === 1 ? "Publicar" : "Finalizar"}
                    </Button>
                  )}
                </center>
              )}
            </Grid>
          </Grid>
        </MuiDialogContent>
        <MuiDialogActions>
          <Button onClick={handleCloseDialog(true)}>
            <Cancel />
          </Button>
        </MuiDialogActions>
      </Dialog>
    </Fragment>
  );
}
